import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CreateOrderHistoryRequestData,
  CreateOrderHistoryResponse,
  OrderHistoryResponse,
  UpdateAppHistoryRequestData,
} from './order-history.domain';
import { CommunicationService } from '../../../services/communication.service';

@Injectable()
export class OrderHistoryService {
  constructor(private communicationService: CommunicationService) {}

  getAppHistoryData(applicationId: string): Observable<OrderHistoryResponse> {
    return this.communicationService.getData(`apphistory?application_id=${applicationId}`);
  }

  createAppHistoryData(requestData: CreateOrderHistoryRequestData): Observable<CreateOrderHistoryResponse> {
    return this.communicationService.postData('apphistory', requestData);
  }

  updateAppHistoryData(id: string, requestData: UpdateAppHistoryRequestData): Observable<OrderHistoryResponse> {
    return this.communicationService.updateData(`apphistory?log_id=${id}`, requestData);
  }

  deleteAppHistoryData(id: string): Observable<any> {
    return this.communicationService.deleteData(`apphistory?log_id=${id}`);
  }
}
